<form #f="ngForm" novalidate>
    <div class="form-group">
        <label for="SelectFile" class="col-form-label" translate>PLEASE_SELECT_FILE</label>
        <div>

        </div>
    </div>
</form>